"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styles = _interopRequireDefault(require("../styles"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _tokens = require("../styles/tokens");
var _excluded = ["classes", "className", "text", "type", "icon"];
var styles = function styles(theme) {
  return {
    // Necessary style overrides are set here
    root: {
      display: 'inline-block',
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.body3.fontSize,
      padding: _tokens.spacing10 + " " + _tokens.spacing30,
      borderRadius: _tokens.borderRadiusXSmall,
      backgroundColor: theme.palette.grey[100],
      lineHeight: _tokens.lineHeightHeader3,
      '& svg': {
        display: 'block',
        float: 'left',
        height: _tokens.sizingSmall,
        width: _tokens.sizingSmall,
        marginRight: _tokens.spacing20
      }
    },
    default: {
      border: _tokens.borderWidthThin + " solid " + theme.palette.status.default.text,
      color: theme.palette.status.default.text,
      fill: theme.palette.status.default.text
    },
    draft: {
      border: _tokens.borderWidthThin + " solid " + theme.palette.status.warning.text,
      color: theme.palette.status.warning.text,
      fill: theme.palette.status.warning.text
    },
    error: {
      border: _tokens.borderWidthThin + " solid " + theme.palette.status.error.text,
      color: theme.palette.status.error.text,
      fill: theme.palette.status.error.text
    },
    pending: {
      border: _tokens.borderWidthThin + " solid " + theme.palette.status.neutral.text,
      color: theme.palette.status.neutral.text,
      fill: theme.palette.status.neutral.text
    },
    success: {
      border: _tokens.borderWidthThin + " solid " + theme.palette.status.success.text,
      color: theme.palette.status.success.text,
      fill: theme.palette.status.success.text
    }
  };
};

/**
 * Use a `StatusLabel` to indicate the status or category of an item.
 * @done true
 * @updated v7.7.0
 * @versionAdded v0.0.10
 * @examples
 *  StatusLabelExample
 *  StatusLabelIcons
 *  StatusLabelTableExample
 *  StatusLabelText
 */
var StatusLabel = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var _classNames;
  var classes = props.classes,
    className = props.className,
    textProp = props.text,
    typeProp = props.type,
    icon = props.icon,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var text = textProp.toUpperCase();
  var type = typeProp.toLowerCase();
  var classOverrides = {
    //CSS classes to override from Material UI Typography CSS API
    root: (0, _classnames.default)(classes.root, (_classNames = {}, _classNames[classes.default] = type === 'default', _classNames[classes.draft] = type === 'draft', _classNames[classes.error] = type === 'error', _classNames[classes.pending] = type === 'pending', _classNames[classes.success] = type === 'success', _classNames), className)
  };
  return /*#__PURE__*/_react.default.createElement(_Typography.default, (0, _extends2.default)({
    component: "span",
    classes: classOverrides,
    ref: ref
  }, rest), icon, text);
});
StatusLabel.muiName = 'StatusLabel';
StatusLabel.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * @ignore
   */
  className: _propTypes.default.string,
  /**
   * Icon component to be displayed to the the left of the status text
   */
  icon: _propTypes.default.node,
  /**
   * Text for the component to display
   */
  text: _propTypes.default.string.isRequired,
  /**
   * Type of status to indicate (default, draft, error, pending, success)
   */
  type: _propTypes.default.oneOf(['default', 'draft', 'error', 'pending', 'success']),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object])
};
StatusLabel.displayName = 'StatusLabel';
StatusLabel.defaultProps = {
  type: 'default'
};
var _default = exports.default = (0, _styles.default)(styles)(StatusLabel);